import type React from "react";
import { Typography } from "../../../../../../shared/frontend/ui";
import type { UnitsSettings } from "../../app/units/units";
import { dashboardListDateParts } from "./dashboardListDateParts";

const COLUMN_STYLE: React.CSSProperties = { whiteSpace: "nowrap" };
const TIME_STYLE: React.CSSProperties = { color: "var(--mq-theme-text-3)" };

/** Darstellung von `dashboardListDateParts`: Datum, Uhrzeit etwas blasser dahinter, ohne Komma. */
export function DashboardListDate({ value, units, withTime }: { value: string | null | undefined; units: UnitsSettings | undefined; withTime?: boolean }) {
  const { date, time } = dashboardListDateParts(value, units, withTime);
  return (
    <Typography.Text type="secondary" style={COLUMN_STYLE}>
      {date ?? (time ? null : "—")}
      {date && time ? " " : null}
      {time ? <span style={date ? TIME_STYLE : undefined}>{time}</span> : null}
    </Typography.Text>
  );
}
